import { Box, Collapse, Typography, useTheme } from '@mui/material';
import { GantWP } from './GantWP';
import { tokens } from '../../../global/theme/tokens';
import { WorkPackageForm } from '../project/workPackage/WorkPackageForm';
import { useState } from 'react';
import { updateOrCreate } from '../../special/updateOrCreate';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { GantPopper } from './GantPopper';
export const GantPhase = ({
  phase,
  isFirst,
  dayWidth,
  onChange,
  days,
  inEditMode,
  projectId,
  resolution,
  allowedStatuses,
  editable,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const { name, workPackages } = phase;
  const [showPackages, setShowPackages] = useState(true);

  const [showWP, setShowWP] = useState(null);
  const [editWP, setEditWP] = useState(null);
  function handleUpdateWorkPackage(updatedWP) {
    const newWorkPackages = updateOrCreate(workPackages, updatedWP);

    onChange({ ...phase, workPackages: newWorkPackages });
  }

  const handleClick = (event, wp) => {
    const clickX = event.clientX;
    const clickY = event.clientY;
    const virtualAnchor = {
      getBoundingClientRect: () => ({
        top: clickY,
        left: clickX,
        bottom: clickY,
        right: clickX,
        width: 0,
        height: 0,
        x: clickX,
        y: clickY,
        toJSON: () => {},
      }),
    };

    setShowWP({ wp: wp, anchor: virtualAnchor }); //event.target });
  };

  return (
    <Box
      sx={{
        borderTop: `1px dashed ${colors.card}`,
      }}
      className="pb-4"
    >
      <Typography
        fontWeight={600}
        className="pl-2 pt-[1px] cursor-pointer"
        onClick={() => setShowPackages(!showPackages)}
      >
        <ArrowDropDownIcon
          sx={{
            transform: `rotate(${showPackages ? 180 : 0}deg)`,
          }}
          className="mr-1"
        />
        {name}
      </Typography>
      <Collapse in={showPackages}>
        <Box className="flex flex-col gap-1 pt-2">
          {workPackages?.map((workPackage) => (
            <GantWP
              key={workPackage.id}
              workPackage={workPackage}
              dayWidth={dayWidth}
              onEdit={(data) => {
                setEditWP(data);
                setShowWP(null);
              }}
              onShow={handleClick}
              days={days}
              inEditMode={inEditMode}
              projectId={projectId}
              onChange={handleUpdateWorkPackage}
              resolution={resolution}
              allowedStatuses={allowedStatuses}
              editable={editable}
            />
          ))}
        </Box>
      </Collapse>
      <WorkPackageForm
        phaseId={phase.id}
        open={Boolean(editWP)}
        onClose={() => setEditWP(null)}
        startDataCollection={editWP}
        onChange={handleUpdateWorkPackage}
      />
      <GantPopper
        open={Boolean(showWP)}
        anchorEl={showWP?.anchor}
        workPackage={showWP?.wp}
        projectId={projectId}
        onClose={() => setShowWP(null)}
      />
    </Box>
  );
};
